import { render, staticRenderFns } from "./list.vue?vue&type=template&id=dcb1affe"
import script from "./list.ts?vue&type=script&lang=js&external"
export * from "./list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb1affe')) {
      api.createRecord('dcb1affe', component.options)
    } else {
      api.reload('dcb1affe', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=dcb1affe", function () {
      api.rerender('dcb1affe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/metodoPagamento/list.vue"
export default component.exports